module.exports = __webpack_public_path__ + "img/skate-quiz-synchronized.4b673560.png";